import { GLOBAL_FETCH_SIGNAL, fetchUrl } from './settings';

import { Action } from './Action';
import { ActionType } from '../action-types';
import { Dispatch } from 'redux';
import axios from 'axios';
import { getSystemFullWithoutClearingPreviousData, getSystemMapImage } from './dashboardActions';
import { getSystems2, getNodes } from '../actions/actions';
import { updateAssignmentByID, getVisibleSystemsForAccountShort } from '../actions/accountActions';
import _ from 'lodash';

export const addSystem = (name, systemVersion, externalSystemName) => (dispatch) => {
	let token = localStorage.getItem('w4-token');

	dispatch({ type: ActionType.DISABLE_SYSTEM_SUBMIT });
	fetch(`${fetchUrl}/system`, {
		method: 'PUT',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({
			Name: name,
			SystemVersion: systemVersion,
			ExternalSystemID: externalSystemName,
		}),
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			const { NewSystemID } = data;
			if (NewSystemID > 0) {
				Promise.all([
					dispatch({ type: ActionType.CREATE_SYSTEM, payload: { NewSystemID } }),
					// ]).then(() => {
					dispatch(getSystems2()),
					dispatch(getSystemsForInstallerPanel()),
				])
                .then(() => {
                    dispatch({ type: ActionType.SYSTEM_SAVE_SUCCESSFULLY });
                    dispatch({ type: ActionType.DISABLE_SYSTEM_SUBMIT });
                });
			} else {
				dispatch({ type: ActionType.SYSTEM_SAVE_FAIL });
				// alert(`The system could not be created. Maybe a system with the specified name: ${name} already exists.`)
				// throw new Error(`Operation unsuccessful. DB response: ${data.NewSystemID}`)
				dispatch({ type: ActionType.DISABLE_SYSTEM_SUBMIT });
			}
		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.DISABLE_SYSTEM_SUBMIT });
		});
};

export const addNode = (SystemID: number, DeviceSerialString: string, Name: string) => (dispatch) => {
	let token = localStorage.getItem('w4-token');

	dispatch({ type: ActionType.DISABLE_NODE_SUBMIT });
	dispatch({ type: ActionType.TOGGLE_CREATE_NODE_BUTTON });
	fetch(`${fetchUrl}/node`, {
		method: 'PUT',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({ SystemID: SystemID, DeviceSerialString: DeviceSerialString, Name: Name }),
	})
		.then((resp) => {
			if (!resp.ok) {
				throw new Error('Node was not added');
			}
			return resp.json();
		})
		.then((data) => {
			if (data.result <= 0) {
				dispatch({ type: ActionType.CREATE_NODE_FAIL });
			} else {
				dispatch({ type: ActionType.CREATE_NODE_SUCCESS });
			}
			dispatch({ type: ActionType.DISABLE_NODE_SUBMIT });
			dispatch({ type: ActionType.TOGGLE_CREATE_NODE_BUTTON });
			// dispatch({ type: ActionType.CREATE_NODE, payload: { name: Name, DeviceID: DeviceID }, })
		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.DISABLE_NODE_SUBMIT });
			dispatch({ type: ActionType.CREATE_NODE_FAIL });
		});
};

export const getFreeDevices = () => (dispatch) => {
	dispatch({ type: ActionType.TOGGLE_REFRESH_BUTTON });
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/devices/free`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_FREE_DEVICES, FreeDevices: data });
			dispatch({ type: ActionType.TOGGLE_REFRESH_BUTTON });
		})
		.catch((err) => {
			console.error('GET_FREE_DEVICES failed');
		});
};

export const getDevices = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/devices`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_DEVICES, devices: data ?? [] });
		})
		.catch((err) => {
			console.error('GET_DEVICES failed');
			dispatch({ type: ActionType.GET_DEVICES, devices: [] });
		});
};

export const getGateways = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/gateways`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_GATEWAYS, gateways: data ?? [] });
		})
		.catch((err) => {
			console.error('GET_GATEWAYS failed');
			dispatch({ type: ActionType.GET_GATEWAYS, gateways: [] });
		});
};

export const getSystemsMapsInfo = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/systems-maps-info`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_SYSTEMS_MAPS_INFO, systemsMapsInfo: data ?? [] });
		})
		.catch((err) => {
			console.error('GET_SYSTEMS_MAPS_INFO failed');
			dispatch({ type: ActionType.GET_SYSTEMS_MAPS_INFO, systemsMapsInfo: [] });
		});
};

export const addAccount = (name, email, phone, password, systemIDs, accountTypes, notifs) => (dispatch, getState) => {
	let token = localStorage.getItem('w4-token');
	let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	dispatch({ type: ActionType.DISABLE_CREATE_ACCOUNT_SUBMIT });
	dispatch({ type: ActionType.TOGGLE_CREATE_ACCOUNT_BUTTON });
	fetch(`${fetchUrl}/account`, {
		method: 'PUT',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({ name, email, phone, password, timezone }),
	})
		.then(async (resp) => {
			const data = await resp.json();
			if (resp.status === 200 || resp.status === 201) {
				const newId = data.id;
				await dispatch(pinUserToSystems(newId, systemIDs, accountTypes, notifs));
				dispatch({ type: ActionType.CREATE_ACCOUNT_SUCCEEDED, name, email, newId });
			} else {
				dispatch({ type: ActionType.CREATE_ACCOUNT_FAILED });
			}
			dispatch({ type: ActionType.DISABLE_CREATE_ACCOUNT_SUBMIT });
			return data;
		}).catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.DISABLE_CREATE_ACCOUNT_SUBMIT });
		});
};

// skipNotifications: the notification settings of the pinned account can't be changed by the current user
// (a commoner pinning an administrator of a shared system) - only pin, they set their notifications themselves
export const pinUserToSystems = (accountID: number, systemIDs: number[], accountTypes: object, notifs: object, skipNotifications = false) => (dispatch, getState) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/account/pin`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({ accountID, systemIDs, accountTypes }),
	})
		.then((resp) => {
			if (resp.status !== 200 && resp.status !== 201) {
				dispatch({ type: ActionType.PIN_ACCOUNT_FAILED });
				throw new Error('User was not pinned.');
			} 
			return dispatch(getVisibleSystemsForAccountShort(accountID));
		}).then(() => {
			if (skipNotifications) return;
			return Promise.all(systemIDs?.map(sysID => {
				let emailNotifs = notifs?.email[sysID] ?? [];
				let pushNotifs = notifs?.push[sysID] ?? [];
				let smsNotifs = notifs?.sms[sysID] ?? [];
				let details = _.filter(getState().dashboard.accounts, { id: accountID })[0]?.systemsDetails;
				let updatedAt = _.filter(details, { ID: sysID })[0]?.AssignmentUpdatedAt ?? null;
				return dispatch(updateAssignmentByID(accountID, sysID, accountTypes[sysID], updatedAt, emailNotifs, pushNotifs, smsNotifs));
			}))
		}).then(() => {
			dispatch({ type: ActionType.PIN_ACCOUNT_SUCCEEDED });	
		})
		.catch((err) => {
			dispatch({ type: ActionType.PIN_ACCOUNT_FAILED });
			console.error(err);
		});
};

export const getFreeSystems = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/systems`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_FREE_SYSTEMS, FreeSystems: data });
		})
		.catch((err) => {
			console.error('GET_FREE_SYSTEMS failed');
		});
};

export const getSystemsVeryShort = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/systems-very-short`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_SYSTEMS_VERY_SHORT, systems: data });
		})
		.catch((err) => {
			console.error('GET_FREE_SYSTEMS failed');
		});
};


export const getInspections = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/inspections`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_INSPECTIONS, inspections: data });
		})
		.catch((err) => {
			console.error('GET_INSPECTIONS failed');
		});
};

export const updateInspection = (inspection) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/inspection`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(inspection),
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			if (data.succeeded) {
				dispatch({
					type: ActionType.UPDATE_INSPECTION_SUCCESS, inspection: inspection });
			} else {
				dispatch({ type: ActionType.UPDATE_INSPECTION_FAILED });
			}
		})
		.catch((error) => {
			dispatch({ type: ActionType.UPDATE_INSPECTION_FAILED });
			console.error(error);
		});
};

export const addInspection = (inspection) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/inspection`, {
		method: 'PUT',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(inspection),
	})
		.then((resp) => {
			if (resp.status !== 200 && resp.status !== 201) {
				dispatch({ type: ActionType.CREATE_INSPECTION_FAILED });
			}
			return resp.json();
		})
		.then((data) => {
			if (data.ID > 0) {
				dispatch({ type: ActionType.CREATE_INSPECTION_SUCCESS, inspection: data });
				return data;
			} else {
				dispatch({ type: ActionType.CREATE_INSPECTION_FAILED });
				return null;
			}

		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.CREATE_INSPECTION_FAILED });
			return null;
		});
};

export const deleteInspection = (inspectionId: number) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/inspection`, {
		method: 'DELETE',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ ID: inspectionId }),
	})
		.then((res) => {
			if (res.status !== 200) {
				throw new Error('Inspection was not deleted');
			}
			return res;
		})
		.then(() => {
			dispatch({ type: ActionType.DELETE_INSPECTION_SUCCESS, inspectionId: inspectionId });
		})
		.catch((error) => {
			dispatch({ type: ActionType.DELETE_INSPECTION_FAILED });
			console.error(error);
		});
};

export const closeUpdateInspectionSuccessNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_UPDATE_INSPECTION_SUCCESS_NOTIFICATION });
};

export const closeUpdateInspectionFailNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_UPDATE_INSPECTION_FAIL_NOTIFICATION });
};

export const closeCreateInspectionSuccessNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_CREATE_INSPECTION_SUCCESS_NOTIFICATION });
};

export const closeCreateInspectionFailNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_CREATE_INSPECTION_FAIL_NOTIFICATION });
};

const clientRequest = (method: string, path: string, body?: any) =>
	fetch(`${fetchUrl}${path}`, {
		method,
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${localStorage.getItem('w4-token')}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: body === undefined ? undefined : JSON.stringify(body),
	});

export const generateExternalSystemId = () => (): Promise<string | null> => {
	return clientRequest('GET', '/external-system-id/new')
		.then((resp) => {
			if (!resp.ok) throw new Error(`Generate external system id failed: ${resp.status}`);
			return resp.json();
		})
		.then((data) => data.externalSystemId ?? null)
		.catch((err) => {
			console.error(err);
			return null;
		});
};

// resets sensor error counters of the nodes of a system, or of all systems without systemId, or of a single node (wisene only);
// resolves to the number of reset nodes, null on error.
// The result of a single system reset is shown in a snackbar on the dashboard; the installer panel (all systems) shows its own
export const resetSensorErrorCounts = (systemId: number | null, nodeId: number | null = null) => (dispatch): Promise<number | null> => {
	return clientRequest('POST', '/sensor-error-counts/reset', { systemId, nodeId })
		.then((resp) => {
			if (!resp.ok) throw new Error(`Reset sensor error counts failed: ${resp.status}`);
			return resp.json();
		})
		.then((data) => data.ResetSensorErrorCounts)
		.catch((err) => {
			console.error(err);
			return null;
		})
		.then((count) => {
			if (systemId !== null) {
				dispatch({ type: ActionType.RESET_SENSOR_ERROR_COUNTS, success: count !== null });
			}
			return count;
		});
};

export const closeResetSensorErrorCountsNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_RESET_SENSOR_ERROR_COUNTS_NOTIFICATION });
};

// wisene/installer accounts that can perform inspections
export const getInspectionPerformers = () => (dispatch) => {
	return clientRequest('GET', '/inspection-performers')
		.then((resp) => {
			if (!resp.ok) throw new Error(`GET_INSPECTION_PERFORMERS failed: ${resp.status}`);
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_INSPECTION_PERFORMERS, performers: data });
		})
		.catch((err) => {
			console.error(err);
		});
};

export const getClients = () => (dispatch) => {
	return clientRequest('GET', '/clients')
		.then((resp) => {
			if (!resp.ok) throw new Error(`GET_CLIENTS failed: ${resp.status}`);
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_CLIENTS, clients: data });
		})
		.catch(() => {
			console.error('GET_CLIENTS failed');
		});
};

// add/update/delete resolve to whether it succeeded; the list is reloaded afterwards
const changeClient = (method: string, client) => (dispatch): Promise<boolean> => {
	return clientRequest(method, '/client', client)
		.then((resp) => {
			if (!resp.ok) return false;
			dispatch(getClients());
			return true;
		})
		.catch((err) => {
			console.error(err);
			return false;
		});
};

export const addClient = (client) => changeClient('PUT', client);
export const updateClient = (client) => changeClient('PATCH', client);
export const deleteClient = (ID: number) => changeClient('DELETE', { ID });

export const saveSystemClients = (systemID: number, buyerClientId: number | null, servicePurchaserClientId: number | null) => (dispatch) => {
	return clientRequest('PATCH', '/system/clients', { systemID, buyerClientId, servicePurchaserClientId })
		.then((resp) => {
			if (!resp.ok) {
				throw new Error('System clients update failed');
			}
			dispatch({ type: ActionType.SAVE_PARAMETERS_SETTINGS_SUCCESSFULLY });
			dispatch(getSystemFullWithoutClearingPreviousData(systemID));
		})
		.catch((err) => {
			dispatch({ type: ActionType.SAVE_PARAMETERS_SETTINGS_FAILED });
			console.error(err);
		});
};

export const getAgreements = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/agreements`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_AGREEMENTS, agreements: data });
		})
		.catch((err) => {
			console.error('GET_AGREEMENTS failed');
		});
};

export const updateAgreement = (agreement) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/agreement`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(agreement),
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			if (data.succeeded) {
				dispatch({
					type: ActionType.UPDATE_AGREEMENT_SUCCESS, agreement: agreement });
			} else {
				dispatch({ type: ActionType.UPDATE_AGREEMENT_FAILED });
			}
		})
		.catch((error) => {
			dispatch({ type: ActionType.UPDATE_AGREEMENT_FAILED });
			console.error(error);
		});
};

export const addAgreement = (agreement) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/agreement`, {
		method: 'PUT',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(agreement),
	})
		.then((resp) => {
			if (resp.status !== 200 && resp.status !== 201) {
				dispatch({ type: ActionType.CREATE_AGREEMENT_FAILED });
			}
			return resp.json();
		})
		.then((data) => {
			if (data.ID > 0) {
				dispatch({ type: ActionType.CREATE_AGREEMENT_SUCCESS, agreement: data });
			} else {
				dispatch({ type: ActionType.CREATE_AGREEMENT_FAILED });
			}
		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.CREATE_AGREEMENT_FAILED });
		});
};

export const deleteAgreement = (ID: number) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/agreement`, {
		method: 'DELETE',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ ID: ID }),
	})
		.then((res) => {
			if (res.status !== 200) {
				throw new Error('Agreement was not deleted');
			}
			return res;
		})
		.then(() => {
			dispatch({ type: ActionType.DELETE_AGREEMENT_SUCCESS, ID: ID });
		})
		.catch((error) => {
			dispatch({ type: ActionType.DELETE_AGREEMENT_FAILED });
			console.error(error);
		});
};

export const closeUpdateAgreementSuccessNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_UPDATE_AGREEMENT_SUCCESS_NOTIFICATION });
};

export const closeUpdateAgreementFailNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_UPDATE_AGREEMENT_FAIL_NOTIFICATION });
};

export const closeCreateAgreementSuccessNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_CREATE_AGREEMENT_SUCCESS_NOTIFICATION });
};

export const closeCreateAgreementFailNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_CREATE_AGREEMENT_FAIL_NOTIFICATION });
};

export const getServiceActions = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/service-actions`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			if (resp.status !== 200) {
				throw new Error('Fail');
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_SERVICE_ACTIONS, serviceActions: data });
		})
		.catch((err) => {
			console.error('GET_SERVICE_ACTIONS failed');
		});
};

export const updateServiceAction = (serviceAction) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/service-action`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(serviceAction),
	})
		.then((resp) => {
			if (resp.status !== 200) {
				throw new Error('Fail');
			}
			return resp.json();
		})
		.then((data) => {
			if (data.succeeded) {
				dispatch({
					type: ActionType.UPDATE_SERVICE_ACTION_SUCCESS, serviceAction: serviceAction });
			} else {
				dispatch({ type: ActionType.UPDATE_SERVICE_ACTION_FAILED });
			}
		})
		.catch((error) => {
			dispatch({ type: ActionType.UPDATE_SERVICE_ACTION_FAILED });
			console.error(error);
		});
};

export const addServiceAction = (serviceAction) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/service-action`, {
		method: 'PUT',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(serviceAction),
	})
		.then((resp) => {
			if (resp.status !== 200 && resp.status !== 201) {
				dispatch({ type: ActionType.CREATE_SERVICE_ACTION_FAILED });
			}
			return resp.json();
		})
		.then((data) => {
			if (data.ID > 0) {
				dispatch({ type: ActionType.CREATE_SERVICE_ACTION_SUCCESS, serviceAction: data });
				return data;
			} else {
				dispatch({ type: ActionType.CREATE_SERVICE_ACTION_FAILED });
				return null;
			}

		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.CREATE_SERVICE_ACTION_FAILED });
			return null;
		});
};

export const deleteServiceAction = (serviceActionId: number) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/service-action`, {
		method: 'DELETE',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ ID: serviceActionId }),
	})
		.then((res) => {
			if (res.status !== 200) {
				throw new Error('Service action was not deleted');
			}
			return res;
		})
		.then(() => {
			dispatch({ type: ActionType.DELETE_SERVICE_ACTION_SUCCESS, serviceActionId: serviceActionId });
		})
		.catch((error) => {
			dispatch({ type: ActionType.DELETE_SERVICE_ACTION_FAILED });
			console.error(error);
		});
};

export const getServiceActionsForInspection = (inspectionId: number) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/service-actions/by-inspection/${inspectionId}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			if (resp.status !== 200) {
				throw new Error('Fail');
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_INSPECTION_SERVICE_ACTIONS, serviceActions: data });
		})
		.catch((err) => {
			console.error('GET_INSPECTION_SERVICE_ACTIONS failed');
			dispatch({ type: ActionType.GET_INSPECTION_SERVICE_ACTIONS_FAILED });
		});
};

export const clearInspectionServiceActions = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLEAR_INSPECTION_SERVICE_ACTIONS });
};

export const getAuditChangesForSystem = (systemId: number) => (dispatch) => {
	dispatch({ type: ActionType.GET_AUDIT_CHANGES_START });
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/audit-changes/${systemId}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			if (resp.status !== 200) {
				throw new Error('Fail');
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_AUDIT_CHANGES, auditChanges: data });
		})
		.catch((err) => {
			console.error('GET_AUDIT_CHANGES failed');
			dispatch({ type: ActionType.GET_AUDIT_CHANGES_FAILED });
		});
};

export const getServiceActionAttachments = (serviceActionId: number) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/service-action-attachments/${serviceActionId}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			if (resp.status !== 200) {
				throw new Error('Fail');
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_SERVICE_ACTION_ATTACHMENTS, attachments: data });
		})
		.catch((err) => {
			console.error('GET_SERVICE_ACTION_ATTACHMENTS failed');
			dispatch({ type: ActionType.GET_SERVICE_ACTION_ATTACHMENTS_FAILED });
		});
};

export const clearServiceActionAttachments = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLEAR_SERVICE_ACTION_ATTACHMENTS });
};

export const addServiceActionAttachment = (attachment) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/service-action-attachment`, {
		method: 'PUT',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(attachment),
	})
		.then((resp) => {
			if (resp.status !== 200 && resp.status !== 201) {
				dispatch({ type: ActionType.CREATE_SERVICE_ACTION_ATTACHMENT_FAILED });
			}
			return resp.json();
		})
		.then((data) => {
			if (data.id > 0) {
				dispatch({ type: ActionType.CREATE_SERVICE_ACTION_ATTACHMENT_SUCCESS, attachment: data });
				return data;
			} else {
				dispatch({ type: ActionType.CREATE_SERVICE_ACTION_ATTACHMENT_FAILED });
				return null;
			}
		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.CREATE_SERVICE_ACTION_ATTACHMENT_FAILED });
			return null;
		});
};

export const deleteServiceActionAttachment = (attachmentId: number) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/service-action-attachment`, {
		method: 'DELETE',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ ID: attachmentId }),
	})
		.then((res) => {
			if (res.status !== 200) {
				throw new Error('Attachment was not deleted');
			}
			return res;
		})
		.then(() => {
			dispatch({ type: ActionType.DELETE_SERVICE_ACTION_ATTACHMENT_SUCCESS, attachmentId: attachmentId });
		})
		.catch((error) => {
			dispatch({ type: ActionType.DELETE_SERVICE_ACTION_ATTACHMENT_FAILED });
			console.error(error);
		});
};

export const getServiceActionPartImages = (serviceActionId: number) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/service-action-part-images/${serviceActionId}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			if (resp.status !== 200) {
				throw new Error('Fail');
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_SERVICE_ACTION_PART_IMAGES, images: data });
		})
		.catch((err) => {
			console.error('GET_SERVICE_ACTION_PART_IMAGES failed');
			dispatch({ type: ActionType.GET_SERVICE_ACTION_PART_IMAGES_FAILED });
		});
};

export const clearServiceActionPartImages = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLEAR_SERVICE_ACTION_PART_IMAGES });
};

export const addServiceActionPartImage = (image) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/service-action-part-image`, {
		method: 'PUT',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(image),
	})
		.then((resp) => {
			if (resp.status !== 200 && resp.status !== 201) {
				dispatch({ type: ActionType.CREATE_SERVICE_ACTION_PART_IMAGE_FAILED });
			}
			return resp.json();
		})
		.then((data) => {
			if (data.id > 0) {
				dispatch({ type: ActionType.CREATE_SERVICE_ACTION_PART_IMAGE_SUCCESS, image: data });
				return data;
			} else {
				dispatch({ type: ActionType.CREATE_SERVICE_ACTION_PART_IMAGE_FAILED });
				return null;
			}
		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.CREATE_SERVICE_ACTION_PART_IMAGE_FAILED });
			return null;
		});
};

export const deleteServiceActionPartImage = (imageId: number) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/service-action-part-image`, {
		method: 'DELETE',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ ID: imageId }),
	})
		.then((res) => {
			if (res.status !== 200) {
				throw new Error('Part image was not deleted');
			}
			return res;
		})
		.then(() => {
			dispatch({ type: ActionType.DELETE_SERVICE_ACTION_PART_IMAGE_SUCCESS, imageId: imageId });
		})
		.catch((error) => {
			dispatch({ type: ActionType.DELETE_SERVICE_ACTION_PART_IMAGE_FAILED });
			console.error(error);
		});
};

export const closeUpdateServiceActionSuccessNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_UPDATE_SERVICE_ACTION_SUCCESS_NOTIFICATION });
};

export const closeUpdateServiceActionFailNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_UPDATE_SERVICE_ACTION_FAIL_NOTIFICATION });
};

export const closeCreateServiceActionSuccessNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_CREATE_SERVICE_ACTION_SUCCESS_NOTIFICATION });
};

export const closeCreateServiceActionFailNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_CREATE_SERVICE_ACTION_FAIL_NOTIFICATION });
};

export const closeMapUploadNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_MAP_UPLOAD_NOTIFICATION });
};

export const closeSaveParametersSettingsNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_SAVE_PARAMETERS_SETTINGS_NOTIFICATION });
};

export const closeNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_NOTIFICATION });
};

export const closeCreateNodeNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_CREATE_NODE_NOTIFICATION });
};

export const closeCreateAccountNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_CREATE_ACCOUNT_NOTIFICATION });
};

export const closeNodeRecalculatedNotification = (nodeName) => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_NODE_RECALCULATED_NOTIFICATION, nodeName: nodeName });
};

export const closeNodeWillRecalculateNotification = (nodeName) => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_NODE_WILL_RECALCULATE_NOTIFICATION, nodeName: nodeName });
};

export const closeNodeAcceleratedNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_NODE_ACCELERATED_NOTIFICATION });
};

export const closeAcceleratedNodesNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_ACCELERATED_NODES_NOTIFICATION });
};

export const savePoints = (systemID: number, nodesCoordinates) => (dispatch: Dispatch<Action>) => {
	const token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.CLOSE_SAVE_POINTS_AND_POLYGONS_NOTIFICATION });

	for (const nodeC of nodesCoordinates) {
		const { x, y, updatedViaWebsiteAt, id } = nodeC;
		fetch(`${fetchUrl}/node/map-position`, {
			method: 'PATCH',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			signal: GLOBAL_FETCH_SIGNAL,
			body: JSON.stringify({ systemID, x, y, updatedViaWebsiteAt, id }),
		})
			.then((resp) => {
				return resp.json();
			})
			.then((data) => {
				if (!data.succeeded) {
					dispatch({ type: ActionType.SAVE_POINTS_FAILED });
					throw new Error(`Node with ID ${id}: coordinates update failed.`);
				} else {
					dispatch({
						type: ActionType.SAVE_POINTS_SUCCESSFULLY,
						nodeId: id,
						updatedViaWebsiteAt: data.updatedAt
					});
				}
			})
			.catch((err) => {
				console.error(err);
			});
	}
};

export const savePolygon = (systemID: number, mapBoundaries: string[], updatedViaWebsiteAt: string) => (dispatch: Dispatch<Action>) => {
	const token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.CLOSE_SAVE_POINTS_AND_POLYGONS_NOTIFICATION });
	fetch(`${fetchUrl}/system/system-map/boundaries`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({ systemID, mapBoundaries, updatedViaWebsiteAt }),
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			if (!data.succeeded) {
				throw new Error('Map boundaries update failed');
			} else {
				dispatch({
					type: ActionType.POLYGON_SAVE_SUCCESS,
					mapBoundaries: mapBoundaries,
					updatedViaWebsiteAt: data.updatedAt,
					systemId: systemID
				});
			}
		})
		.catch((err) => {
			console.error(err);
			return dispatch({ type: ActionType.POLYGON_SAVE_FAILED });
		});
};

export const saveSystemSettings = (settings) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/system`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(settings),
	})
		.then((resp) => {
			if (!resp.ok) {
				dispatch({ type: ActionType.SAVE_PARAMETERS_SETTINGS_FAILED });
				throw new Error('Settings update failed');
			} else {
				dispatch({ type: ActionType.SAVE_PARAMETERS_SETTINGS_SUCCESSFULLY });
				dispatch({ type: ActionType.UPDATE_PICKED_SYSTEM_NAME, payload: true });
			}
			return resp;
		})
		// update current system data without clearing previous data and render loader:
		.then(() => {
			dispatch(getSystemFullWithoutClearingPreviousData(settings.systemID));
		})
		.catch((err) => {
			console.error(err);
		});
};

export const saveW2SystemSettings = (newSettings, oldSettings) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/system/w2-controller-configuration`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(newSettings),
	})
		.then(async (resp) => {
			const data = await resp.json();
			if (!resp.ok) {
				if (data?.newUpdatedAt) {
					// w2ConfigurationUpdatedAt mismatch, update just w2ConfigurationUpdatedAt
					oldSettings.w2ConfigurationUpdatedAt = (new Date(parseInt(data.newUpdatedAt) * 1000)).toISOString();
					dispatch(saveW2SystemSettings2(oldSettings))
				} else {
					dispatch({ type: ActionType.SAVE_PARAMETERS_SETTINGS_FAILED, reason: data.reason });
					throw new Error('W2 configuration update failed');
				}
			} else {
				newSettings.w2ConfigurationUpdatedAt = (new Date(parseInt(data.newUpdatedAt) * 1000)).toISOString();
				dispatch(saveW2SystemSettings2(newSettings))
			}
			return resp;
		})
		.catch((err) => {
			console.error(err);
		});
};

export const saveW2SystemSettings2 = (saveW2SystemSettingsParams) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/system/w2-configuration`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(saveW2SystemSettingsParams),
	})
		.then((resp) => {
			if (!resp.ok) {
				dispatch({ type: ActionType.SAVE_PARAMETERS_SETTINGS_FAILED });
				throw new Error('W2 configuration update failed');
			} else {
				dispatch({ type: ActionType.SAVE_PARAMETERS_SETTINGS_SUCCESSFULLY });
			}
			return resp;
		})
		// update current system data without clearing previous data and render loader:
		.then(() => {
			dispatch(getSystemFullWithoutClearingPreviousData(saveW2SystemSettingsParams.systemID));
		})
		.catch((err) => {
			console.error(err);
		});
};

export const saveW2SystemExtendedSettings = (settings) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/system/w2-extended-configuration`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(settings),
	})
		.then((resp) => {
			if (!resp.ok) {
				dispatch({ type: ActionType.SAVE_PARAMETERS_SETTINGS_FAILED });
				throw new Error('W2 extended settings update failed');
			} else {
				dispatch({ type: ActionType.SAVE_PARAMETERS_SETTINGS_SUCCESSFULLY });
				dispatch({ type: ActionType.UPDATE_PICKED_SYSTEM_NAME, payload: true });
			}
			return resp;
		})
		// update current system data without clearing previous data and render loader:
		.then(() => {
			dispatch(getSystemFullWithoutClearingPreviousData(settings.systemID));
		})
		.catch((err) => {
			console.error(err);
		});
};

export const uploadFile = (formData, systemID) => (dispatch) => {
	dispatch({ type: ActionType.RESET_UPLOAD_MAP_FILE_STATUS });
	const token = localStorage.getItem('w4-token');
	const startProgress = 0;
	const actionTypeMap = {
		'main': ActionType.UPDATE_MAP_UPLOAD_PROGRESS,
		'second': ActionType.UPDATE_SECOND_MAP_UPLOAD_PROGRESS,
		'third': ActionType.UPDATE_THIRD_MAP_UPLOAD_PROGRESS,
		'report': ActionType.UPDATE_REPORT_MAP_UPLOAD_PROGRESS
	};

	const updateActionType = actionTypeMap[formData.get("mapType")];
	dispatch({ type: updateActionType, payload: startProgress });

	axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

	const config = {
		onUploadProgress: (progress) => {
			const { loaded, total } = progress;
			const currentProgress = Math.round((loaded * 100) / total);
			dispatch({ type: updateActionType, payload: currentProgress });
		},
	};
	return axios
		.post(process.env.REACT_APP_API_URL + '/system/system-map', formData, config)
		.then((resp) => {
			if (formData.get("file") == "") {
				dispatch({ type: ActionType.MAP_UPLOAD_SUCCESS, updatedViaWebsiteAt: resp.data.updatedAt, systemId: systemID  });
			}
			dispatch({ type: updateActionType, payload: 100 });
			dispatch({ type: ActionType.MAP_UPLOAD_SUCCESS, updatedViaWebsiteAt: resp.data.updatedAt, systemId: systemID  });
		})
		.then(() => {
			dispatch(getSystemMapImage(systemID));
		})
		.catch((err) => {
			dispatch({ type: updateActionType, payload: 100 });
			dispatch({ type: ActionType.MAP_UPLOAD_FAILED });
			dispatch({ type: ActionType.FAILED_UPLOAD_MAP_FILE });
			console.error('Upload ERROR', err);
		});
};

export const deleteMapFile = (systemID, mapType) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/system-map`, {
		method: 'DELETE',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ systemID: systemID, mapType: mapType }),
	})
		.then((res) => {
			if (res.status !== 200) {
				throw new Error('Map was not deleted');
			}
			return res;
		})
		.then(() => {
			dispatch({ type: ActionType.DELETE_MAP_SUCCEEDED, mapType: mapType});
		})
		.catch((error) => {
			dispatch({ type: ActionType.DELETE_MAP_FAILED });
			console.error(error);
		});
};

export const uploadLogo = (formData) => (dispatch) => {
	dispatch({ type: ActionType.RESET_UPLOAD_LOGO_FILE_STATUS });
	const token = localStorage.getItem('w4-token');
	const startProgress = 0;
	dispatch({ type: ActionType.UPDATE_LOGO_UPLOAD_PROGRESS, payload: startProgress });

	axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

	const config = {
		onUploadProgress: (progress) => {
			const { loaded, total } = progress;
			const currentProgress = Math.round((loaded * 100) / total);
			dispatch({ type: ActionType.UPDATE_LOGO_UPLOAD_PROGRESS, payload: currentProgress });
		},
	};
	return axios
		.post(process.env.REACT_APP_API_URL + '/system/system-logo', formData, config)
		.then((formData) => {
			dispatch({ type: ActionType.UPDATE_LOGO_UPLOAD_PROGRESS, payload: 100 });
			dispatch({ type: ActionType.SAVE_CLIENT_LOGO_SUCCESSFULLY });
		})
		.catch((err) => {
			dispatch({ type: ActionType.UPDATE_LOGO_UPLOAD_PROGRESS, payload: 100 });
			dispatch({ type: ActionType.SAVE_CLIENT_LOGO_FAILED });
			dispatch({ type: ActionType.FAILED_UPLOAD_LOGO_FILE });
		});
};

export const resetMapFileUploadStatus = () => (dispatch) => {
	dispatch({ type: ActionType.RESET_UPLOAD_MAP_FILE_STATUS });
};

export const resetLogoFileUploadStatus = () => (dispatch) => {
	dispatch({ type: ActionType.RESET_UPLOAD_LOGO_FILE_STATUS });
};

export const closeClientLogoNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_CLIENT_LOGO_NOTIFICATION });
};

export const closeSavePointsAndPolygonsNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_SAVE_POINTS_AND_POLYGONS_NOTIFICATION });
};

export const deleteSystem = (systemId: number) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/system`, {
		method: 'DELETE',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ ID: systemId }),
	})
		.then((res) => {
			if (res.status !== 200) {
				throw new Error('System was not deleted');
			}
			return res;
		})
		.then(() => {
			dispatch({ type: ActionType.DELETE_SYSTEM_SUCCESSFULLY, ID: systemId });
		})
		.catch((error) => {
			dispatch({ type: ActionType.DELETE_SYSTEM_FAILED });
			console.error(error);
		});
};

export const getSystemsForInstallerPanel = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/systems-for-installer-panel`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_SYSTEMS_FOR_INSTALLER_PANEL, systems: data });
		})
		.catch((err) => {
			console.error('GET_SYSTEMS_FOR_INSTALLER_PANEL failed');
		});
};

export const setSystemArchived = (systemId: number, archived: boolean) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/system/archived`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ systemID: systemId, archived: archived }),
	})
		.then((res) => {
			if (res.status !== 200) {
				throw new Error('System archived state was not updated');
			}
			return res;
		})
		.then(() => {
			dispatch({ type: ActionType.SET_SYSTEM_ARCHIVED_SUCCESSFULLY, systemId, archived });
		})
		.catch((error) => {
			dispatch({ type: ActionType.SET_SYSTEM_ARCHIVED_FAILED });
			console.error(error);
		});
};

export const closeSetSystemArchivedNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_SET_SYSTEM_ARCHIVED_NOTIFICATION });
};

export const deleteUser = (accountId: number) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/account`, {
		method: 'DELETE',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ ID: accountId }),
	})
		.then((res) => {
			if (res.status !== 200) {
				throw new Error('Account was not deleted');
			}
			return res;
		})
		.then(() => {
			dispatch({ type: ActionType.DELETE_ACCOUNT_SUCCEEDED, id: accountId });
		})
		.catch((error) => {
			dispatch({ type: ActionType.DELETE_ACCOUNT_FAILED });
			console.error(error);
		});
};

export const closeDeleteSystemNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_DELETE_SYSTEM_NOTIFICATION });
};

export const closeDeleteUserNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_DELETE_USER_NOTIFICATION });
};

export const closeDeleteNodeNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_DELETE_NODE_NOTIFICATION });
};

export const closeDeleteSystemGroupNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_DELETE_SYSTEM_GROUP_NOTIFICATION });
};

export const closeDeleteMapNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_DELETE_MAP_NOTIFICATION });
};

export const deleteNode = (nodeId: number, systemId) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/node`, {
		method: 'DELETE',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ id: nodeId }),
	})
		.then((res) => {
			if (res.status !== 200) {
				dispatch({ type: ActionType.DELETE_NODE_FAILED });
				throw new Error('Node was not deleted');
			}
			return res;
		})
		.then(() => {
			dispatch({ type: ActionType.DELETE_NODE_SUCCESSFULLY });
		})
		.then(dispatch(getNodes([systemId])))
		.catch((error) => {
			console.error(error);
		});
};

export const addSystemGroup = (name, isPublic = true) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.DISABLE_SYSTEM_GROUP_SUBMIT });
	fetch(`${fetchUrl}/system-group`, {
		method: 'PUT',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({
			name: name,
			isPublic: isPublic
		}),
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.CREATE_SYSTEM_GROUP, newID: data.newSystemGroupID, name: name, public: isPublic });
		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.CREATE_SYSTEM_GROUP, newID: -1, name: name, public: isPublic });
		});
};


export const deleteSystemGroup = (systemGroupId: number) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/system-group`, {
		method: 'DELETE',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ ID: systemGroupId }),
	})
		.then((res) => {
			if (res.status !== 200) {
				throw new Error('System group was not deleted');
			}
			return res;
		})
		.then(() => {
			dispatch({ type: ActionType.DELETE_SYSTEM_GROUP_SUCCESSFULLY });
		})
		.catch((error) => {
			dispatch({ type: ActionType.DELETE_SYSTEM_GROUP_FAILED });
			console.error(error);
		});
};

export const addSystemsToGroup = (groupID: number, systemIDs: number[]) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/system-group/add-systems`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({ groupID, systemIDs }),
	})
		.then((resp) => {
			if (resp.status === 200 || resp.status === 201) {
				dispatch({ type: ActionType.ADD_SYSTEMS_TO_GROUP_SUCCEEDED });
			} else {
				dispatch({ type: ActionType.ADD_SYSTEMS_TO_GROUP_FAILED });
			}
			return resp.json();
		})
		.catch((err) => {
			console.error(err);
		});
};

export const addUsersToSystemGroup = (groupID: number, accountIDs: number[]) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/system-group/add-accounts`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({ groupID, accountIDs }),
	})
		.then((resp) => {
			if (resp.status === 200 || resp.status === 201) {
				dispatch({ type: ActionType.ADD_ACCOUNTS_TO_SYSTEM_GROUP_SUCCEEDED });
			} else {
				dispatch({ type: ActionType.ADD_ACCOUNTS_TO_SYSTEM_GROUP_FAILED });
			}
			return resp.json();
		})
		.catch((err) => {
			console.error(err);
		});
};

export const closeSettingRainstormModeNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_SET_RAINSTORM_MODE_NOTIFICAION });
};

export const closeSendTestNotificationNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_SEND_TEST_NOTIFICATION_NOTIFICAION });
};

export const closeSettingServiceModeNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_SET_SERVICE_MODE_NOTIFICAION });
};

export const getSimcards = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/simcards`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_SIMCARDS, simcards: data });
		})
		.catch((err) => {
			console.error('GET_SIMCARDS failed');
		});
};

export const getSimcardAssignments = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/simcard-assignments`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_SIMCARD_ASSIGNMENTS, simcardAssignments: data });
		})
		.catch((err) => {
			console.error('GET_SIMCARDS failed');
		});
};


export const getSimcard = (simcardId) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/simcards/${simcardId}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_SIMCARD, currentSimcard: data });
		})
		.catch((err) => {
			console.error('GET_SIMCARD failed');
		});
};
export const updateSimcard = (simcard) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/simcard`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(simcard),
	})
		.then(async (resp) => {
			if (resp.ok) {
				dispatch({
					type: ActionType.UPDATE_SIMCARD_SUCCESS, simcard: simcard });
			} else {
				const data = await resp.json();
				dispatch({ type: ActionType.UPDATE_SIMCARD_FAILED, message: data?.message });
			}
		})
		.catch((error) => {
			dispatch({ type: ActionType.UPDATE_SIMCARD_FAILED });
			console.error(error);
		});
};

export const addSimcard = (simcard) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/simcard`, {
		method: 'PUT',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(simcard),
	})
		.then(async (resp) => {
			const data = await resp.json();
			if (resp.ok && data.ID > 0) {
				dispatch({ type: ActionType.CREATE_SIMCARD_SUCCESS, simcard: data });
			} else {
				dispatch({ type: ActionType.CREATE_SIMCARD_FAILED, message: data?.message });
			}
		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.CREATE_SIMCARD_FAILED });
		});
};

export const deleteSimcard = (ID: number) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/simcard`, {
		method: 'DELETE',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ ID: ID }),
	})
		.then((res) => {
			if (res.status !== 200) {
				throw new Error('Simcard was not deleted');
			}
			return res;
		})
		.then(() => {
			dispatch({ type: ActionType.DELETE_SIMCARD_SUCCESS, ID: ID });
		})
		.catch((error) => {
			dispatch({ type: ActionType.DELETE_SIMCARD_FAILED });
			console.error(error);
		});
};

export const getNodesVeryShort = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/nodes-very-short`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_NODES_VERY_SHORT, nodes: data });
		})
		.catch((err) => {
			console.error('GET_FREE_SYSTEMS failed');
		});
};

export const closeUpdateSimcardSuccessNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_UPDATE_SIMCARD_SUCCESS_NOTIFICATION });
};

export const closeUpdateSimcardFailNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_UPDATE_SIMCARD_FAIL_NOTIFICATION });
};

export const closeCreateSimcardSuccessNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_CREATE_SIMCARD_SUCCESS_NOTIFICATION });
};

export const closeCreateSimcardFailNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_CREATE_SIMCARD_FAIL_NOTIFICATION });
};



export const getRouters = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/routers`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_ROUTERS, routers: data });
		})
		.catch((err) => {
			console.error('GET_ROUTERS failed');
		});
};

export const getRouter = (routerId) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/routers/${routerId}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_ROUTER, currentRouter: data });
		})
		.catch((err) => {
			console.error('GET_ROUTER failed');
		});
};
export const updateRouter = (router) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/router`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(router),
	})
		.then((resp) => {
			if (!resp.ok) {
				dispatch({ type: ActionType.UPDATE_ROUTER_FAILED });
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({type: ActionType.UPDATE_ROUTER_SUCCESS, router: router, data:data });
		})
		.catch((error) => {
			dispatch({ type: ActionType.UPDATE_ROUTER_FAILED });
			console.error(error);
		});
};

export const addRouter = (router) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/router`, {
		method: 'PUT',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(router),
	})
		.then((resp) => {
			if (resp.status !== 200 && resp.status !== 201) {
				dispatch({ type: ActionType.CREATE_ROUTER_FAILED });
			}
			return resp.json();
		})
		.then((data) => {
			if (data.ID > 0) {
				dispatch({ type: ActionType.CREATE_ROUTER_SUCCESS, router: data });
			} else {
				dispatch({ type: ActionType.CREATE_ROUTER_FAILED });
			}
		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.CREATE_ROUTER_FAILED });
		});
};

export const deleteRouter = (ID: number, simcardId: number, simcardName: string) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/router`, {
		method: 'DELETE',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ ID: ID }),
	})
		.then((res) => {
			if (res.status !== 200) {
				throw new Error('Router was not deleted');
			}
			return res;
		})
		.then(() => {
			dispatch({ type: ActionType.DELETE_ROUTER_SUCCESS, ID: ID, simcardId: simcardId, simcardName: simcardName });
		})
		.catch((error) => {
			dispatch({ type: ActionType.DELETE_ROUTER_FAILED });
			console.error(error);
		});
};

export const getAvailableSimcards = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/free-simcards`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_FREE_SIMCARDS, simcards: data });
		})
		.catch((err) => {
			console.error('GET_FREE_SYSTEMS failed');
		});
};

export const closeUpdateRouterSuccessNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_UPDATE_ROUTER_SUCCESS_NOTIFICATION });
};

export const closeUpdateRouterFailNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_UPDATE_ROUTER_FAIL_NOTIFICATION });
};

export const closeCreateRouterSuccessNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_CREATE_ROUTER_SUCCESS_NOTIFICATION });
};

export const closeCreateRouterFailNotification = () => (dispatch: Dispatch<Action>) => {
	dispatch({ type: ActionType.CLOSE_CREATE_ROUTER_FAIL_NOTIFICATION });
};

export const getSmses = (req) => (dispatch) => {
	dispatch({ type: ActionType.SMSES_LOADING, loading: true });
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/smses`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(req),
		}).then((resp) => {
			return resp.json();
		}).then((data) => {
			dispatch({ type: ActionType.GET_SMSES, smses: data });
		})
		.catch((error) => {
			console.error(error);
		});
};

export const exportSmses = (req, signal?: AbortSignal) => () => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/smses`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: signal ?? GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(req),
	}).then((resp) => resp.json());
};

export const sendSms = (sms) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/send-sms`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(sms),
		}).then((resp) => {
			return resp.json();
		}).then((data) => {
			dispatch({ type: ActionType.SEND_SMS, sms: data });
		})
		.catch((error) => {
			console.error(error);
		});
};

export const getRoutersWithSimcards = (req) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/simcard-routers`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		}).then((resp) => {
			return resp.json();
		}).then((data) => {
			dispatch({ type: ActionType.GET_ROUTERS_WITH_SIMCARDS, routersWithSimcards: data });
		})
		.catch((error) => {
			console.error(error);
		});
};

export const getNodesWithSimcards = (req) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/simcard-nodes`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		}).then((resp) => {
			return resp.json();
		}).then((data) => {
			dispatch({ type: ActionType.GET_NODES_WITH_SIMCARDS, nodesWithSimcards: data });
		})
		.catch((error) => {
			console.error(error);
		});
};

export const getNodeImages = (nodeId) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/node/images/${nodeId}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			if (resp.status !== 200 && resp.status !== 201) {
				dispatch({ type: ActionType.GET_NODE_IMAGES, nodeImages: null, nodeId: nodeId });
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_NODE_IMAGES, nodeImages: data, nodeId: nodeId });
		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.GET_NODE_IMAGES, nodeImages: null, nodeId: nodeId });
		});
};


export const addNodeImage = (image) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/node/images`, {
		method: 'PUT',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(image),
	})
		.then((resp) => {
			if (resp.status !== 200 && resp.status !== 201) {
				dispatch({ type: ActionType.CREATE_NODE_IMAGE_FAILED });
			}
			return resp.json();
		})
		.then((data) => {
			if (data.id > 0) {
				dispatch({ type: ActionType.CREATE_NODE_IMAGE_SUCCESS, nodeImage: data });
			} else {
				dispatch({ type: ActionType.CREATE_NODE_IMAGE_FAILED });
			}
		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.CREATE_NODE_IMAGE_FAILED });
		});
};

export const deleteNodeImage = (imageId: number) => (dispatch) => {
	const token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/nodes/images/${imageId}`, {
		method: 'DELETE',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		}
	})
		.then((res) => {
			if (res.status !== 200) {
				throw new Error('Node image was not deleted');
			}
			return res;
		})
		.then(() => {
			dispatch({ type: ActionType.DELETE_NODE_IMAGE_SUCCESS, ID: imageId });
		})
		.catch((error) => {
			dispatch({ type: ActionType.DELETE_NODE_IMAGE_FAILED });
			console.error(error);
		});
};


export const bindDeviceToNode = (nodeId, deviceSerial) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/node/bind-device`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({nodeID: nodeId, deviceSerial: deviceSerial}),
	})
		.then((resp) => {
			if (resp.ok) {
				dispatch({
					type: ActionType.BIND_DEVICE_TO_NODE_SUCCESS, nodeId: nodeId, deviceSerial: deviceSerial });
			} else {
				console.log('dispatch 1');
				dispatch({ type: ActionType.BIND_DEVICE_TO_NODE_FAILED });
			}
		})
		.catch((error) => {
			console.log('dispatch 1');
			dispatch({ type: ActionType.BIND_DEVICE_TO_NODE_FAILED });
			console.error(error);
		});
};

export const getSystemDetails = (systemID) => (dispatch) => {
	dispatch({ type: ActionType.GET_SYSTEM_DETAILS_START });
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/system/${systemID}/details`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		}).then((resp) => {
			return resp.json();
		}).then((data) => {
			dispatch({ type: ActionType.GET_SYSTEM_DETAILS, systemDetails: data });
		})
		.catch((error) => {
			console.error(error);
			dispatch({ type: ActionType.GET_SYSTEM_DETAILS_FAILED });
		});
};

export const getDeviceDetails = (deviceID) => (dispatch) => {
	dispatch({ type: ActionType.GET_DEVICE_DETAILS_START });
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/device/${deviceID}/details`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		}).then((resp) => {
			return resp.json();
		}).then((data) => {
			dispatch({ type: ActionType.GET_DEVICE_DETAILS, deviceDetails: data });
		})
		.catch((error) => {
			console.error(error);
			dispatch({ type: ActionType.GET_DEVICE_DETAILS_FAILED });
		});
};